import { DataBean } from "../DataBean";

export class TravelExpenses extends DataBean {
  public async updateTravelExpenses(bean: any): Promise<any> {
    return this.getCustomService("TalentERP", "com.orange.people.talent.bean.TravelExpenses_updateTravelExpenses_com.orange.people.talent.bean.TravelExpenses", [
      {
        DataBeanProperties: bean,
        DataBeanName: "com.orange.people.talent.bean.TravelExpenses",
      },
    ]);
  }
}
